import { useCallback, useEffect, useState } from "react";
import { RfxDocumentRow } from "../types/rfx-document.types";

export const useDocumentSelection = (filteredDocs: RfxDocumentRow[]) => {
  const [selectedIds, setSelectedIds] = useState<Set<number>>(new Set());

  // Clear selection when filtered documents change
  useEffect(() => {
    setSelectedIds(new Set());
  }, [filteredDocs]);

  const toggleSelection = useCallback((id: number) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  }, []);

  const selectAll = useCallback(() => {
    setSelectedIds(new Set(filteredDocs.map((d) => d.id)));
  }, [filteredDocs]);

  const clearSelection = useCallback(() => {
    setSelectedIds(new Set());
  }, []);

  const isAllSelected =
    filteredDocs.length > 0 && filteredDocs.every((d) => selectedIds.has(d.id));

  const isIndeterminate =
    selectedIds.size > 0 && !isAllSelected;

  return {
    selectedIds,
    toggleSelection,
    selectAll,
    clearSelection,
    isAllSelected,
    isIndeterminate,
  };
};
